

exports.__esModule = true;
exports.$xoCIPVerficationPageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCIPVerficationPageRoute = exports.$xoCIPVerficationPageRoute = _index.$Route.extend('$xoCIPVerficationPageRoute', {

    path: 'cipverification',
    directive: _directive2['default'],

    trackingData: {
        fptiState: 'cipverification'
    },

    children: []
});

angular.value("$xoCIPVerficationPageRoute", $xoCIPVerficationPageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-cip-verification/route.js
// module id = ./pages/xo-cip-verification/route.js
// module chunks = 0